import React from 'react';
import ButtonGasco from '../../components/button/ButtonGasco';
import { InterfaceRoutes } from '../../interfaces/interfaceRoutes';


const Page1 = (props: InterfaceRoutes) => {
  return (
    <div>
      <p>
        Este es el arquetipo <strong>Usar</strong>
      </p>
      <p>Ejemplo de uso de Botón de Librería Gasco</p>
        <ButtonGasco />
    </div>
  );
};

export default Page1;
